import {Component, Input, OnInit} from '@angular/core';
import {CtaType, UIFeatureFlag, UpcomingPaymentDetails, pageTypes} from '@ox/typings';
import {buildTrackingString} from '@ox/utils';
import {CopyFormattingService, ShopDataService} from '@webu/data';
import {TrackingUrlService} from '../../../services/tracking/tracking-url.service';
import {Store} from '@ngrx/store';
import {selectFeatureFlag} from '@ox/data';
import {takeWhile, tap} from 'rxjs';
@Component({
  selector: 'webu-next-payment',
  templateUrl: './next-payment.component.html'
})
export class NextPaymentComponent implements OnInit{ 
  @Input() nextPayment: UpcomingPaymentDetails;
  billedOn?: string;
  discountDescription: string;
  discountPercentage: string;
  navigateToPaymentMethodPage = this.trackingUrlService.navigateToPaymentMethodPage;
  //Tracking imports
  trackingString = (cta: CtaType, args: string[]) => buildTrackingString(pageTypes.myPlans, cta, args);
  @Input() parentPlanName = '';
  paymentHistoryRedesign: boolean;
  
  constructor(
    private shopDataService : ShopDataService,
    private trackingUrlService: TrackingUrlService,
    private store: Store,
    private copyService: CopyFormattingService
  ) {
    this.store
    .select(selectFeatureFlag({id: UIFeatureFlag.PAYMENT_HISTORY_REDESIGN, group: 'UI'}))
    .pipe(
      takeWhile((val) => !val, true),
      tap((flag) => this.paymentHistoryRedesign = flag === 'true')
    ).subscribe();
  }

  ngOnInit() {
    this.assignText();
  }

  get hasDataSourcePayment(): boolean {
    return this.nextPayment?.nextPayments?.some((payment: {source: string;}) => payment.source === 'DATA') ?? false;
  }

  assignText() {
    this.hasDataSourcePayment ? this.setATTDataText() : this.setNonATTDataText();
    this.discountDescription = this.nextPayment?.discountDescription ?? '';
    this.discountPercentage = this.nextPayment?.discountPercent ?? '';
  }

  setNonATTDataText() {
    if (this.nextPayment && this.nextPayment.nextPayments && this.nextPayment.nextPayments.length > 0) {
      this.billedOn = this.nextPayment.nextPayments[0].paymentText;
    }
  }

  setATTDataText() {
    this.nextPayment?.nextPayments?.forEach((payment : any) => {
      if (payment.source === 'DATA' && payment.links) {
        payment.paymentText = payment.paymentText.replace(payment.links.placeholder, '');
      }
    });
  }

  getGenericCopy$ = (code: string, varMap?: Record<string, string>) => 
    this.copyService.getGenericCopy$(code, varMap);

}
